import { FC, useState } from "react";

import {
  BackButtonContainer,
  GreenP,
  RedP,
  TextDivider,
} from "../../../global.styles";
import PaymentStatus from "../ui/payment-status.component";
import { BookingType } from "../../../redux/bookings/bookings.types";
import Button from "../../UI/button/button.component";
import Checkbox from "../../UI/checkbox/checkbox.component";
import { updateUgisPartnerPaymentStatus } from "../../../firebase/admin";
import Spinner from "../../UI/spinner/spinner.component";

type PartnerPaymentStatusFormProps = {
  bookingDetails: BookingType;
};
const PartnerPaymentStatusForm: FC<PartnerPaymentStatusFormProps> = ({
  bookingDetails,
}) => {
  const [showForm, setShowForm] = useState(false);
  const [partnerPaid, setPartnerPaid] = useState(
    bookingDetails.ugisPartnerDetails!.paid || false
  );
  const [driverPaid, setDriverPaid] = useState(
    bookingDetails.ugisPartnerDetails!.paidToDriver || false
  );
  const [updateLoading, setUpdateLoading] = useState(false);
  const [updateError, setUpdateError] = useState("");

  const updateHandler = async () => {
    setUpdateLoading(true);
    try {
      await updateUgisPartnerPaymentStatus(
        bookingDetails.id!,
        partnerPaid,
        driverPaid
      );
      setShowForm(false);
    } catch (error) {
      if (error instanceof Error) {
        setUpdateError(error.message);
      } else {
        setUpdateError("Error updating Partner payment status!");
      }
    } finally {
      setUpdateLoading(false);
    }
  };

  if (updateLoading) return <Spinner />;

  return (
    <>
      <TextDivider>
        <GreenP> PARTNER JOB DATA </GreenP>
      </TextDivider>
      {!showForm ? (
        <>
          <PaymentStatus
            description={
              bookingDetails.ugisPartnerDetails!.paid
                ? "Partner paid (or no payment required)"
                : "Partner DIDN'T pay"
            }
            paid={bookingDetails.ugisPartnerDetails!.paid ? true : false}
          />
          <PaymentStatus
            description={
              bookingDetails.ugisPartnerDetails!.paidToDriver
                ? "Paid to the Driver (or no payment required)"
                : "Driver NOT paid"
            }
            paid={
              bookingDetails.ugisPartnerDetails!.paidToDriver ? true : false
            }
          />
          <BackButtonContainer>
            <Button onClick={() => setShowForm(true)}>Update</Button>
          </BackButtonContainer>
        </>
      ) : (
        <>
          <Checkbox
            label="Did Partner pay? Or no payment required?"
            id="partnerPaid"
            name="partnerPaid"
            checked={partnerPaid}
            onChange={() => setPartnerPaid(!partnerPaid)}
          />
          <Checkbox
            label="Was Driver paid? Or no payment required?"
            id="driverPaid"
            name="driverPaid"
            checked={driverPaid}
            onChange={() => setDriverPaid(!driverPaid)}
          />
          {updateError && <RedP>{updateError}</RedP>}
          <BackButtonContainer>
            <Button onClick={updateHandler}>Save</Button>
          </BackButtonContainer>
        </>
      )}
    </>
  );
};

export default PartnerPaymentStatusForm;
